import Vue from 'vue';
import {
  ValidationProvider, localize, extend, ValidationObserver,
} from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  confirmed, email, min, regex, required, integer, max, image, max_value, min_value, length,
} from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize('ru', ru);

extend('min', min);
extend('length', length);
extend('integer', integer);
extend('max', max);
extend('max_value', max_value);
extend('min_value', min_value);
extend('email', email);
extend('required', {
  ...required,
  message: 'Данное поле обязательно для заполнения',
});
extend('confirmed', {
  ...confirmed,
  message: 'Поля не совпадают',
});
extend('regex', regex);
extend('image', image);
extend('url', {
  validate(value) {
    if (value) {
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
    }
    return false;
  },
  message: 'Некорректный URL',
});

extend('inn', {
  validate(value) {
    if (value) {
      return /(^.{10}$)|(^.{12})$/.test(value);
    }
    return false;
  },
  message: 'ИНН имеет длину 10 символов или 12 символов',
});

extend('included', {
  params: ['target'],
  validate: (value, { target }) => {
    const arr = target ? [].concat(target) : [];
    return !arr.includes(value);
  },
  message: 'Такое значение уже существует',
});
extend('snils', {
  message: 'Неправильное контрольное число',
  validate: (value) => {
    if (!value || (value && value.length !== 14)) return true;
    const regexVal = /\d+/gm;
    const pureValue = value.match(regexVal);
    const [controlNumber] = pureValue.splice(3, 1);
    const anyNumbers = pureValue.join('').split('');
    const sum = anyNumbers
      .reduce((acc, cur, idx) => acc + Number(cur) * (anyNumbers.length - idx), 0);
    let checkDigit = 0;
    if (sum < 100) {
      checkDigit = sum;
    } else if (sum > 101) {
      checkDigit = sum % 101;
      if (checkDigit === 100) {
        checkDigit = 0;
      }
    }
    if (checkDigit === Number(controlNumber)) return true;
    return false;
  },
});
